import { type PropsWithChildren } from 'react'
import { Stack } from '../../primitives/Stack'
import { spacing } from '../../theme/spacing'
import { useSpacingToken } from '../../theme/hooks/use-spacing-token'

type Props = PropsWithChildren

export const ModalFooter = ({ children }: Props) => {
  const spacingToken = useSpacingToken()

  return (
    <Stack
      sx={{
        display: 'flex',
        flexFlow: 'row wrap',
        padding: spacing(0, spacingToken, spacingToken),
        gap: spacing(2),
      }}
    >
      {children}
    </Stack>
  )
}
